import React, { FC } from "react"

interface IImage {
    src: string,
    placeholder?: string,
    alt?: string,
    width?: number | string,
    height?: number | string,
    className?: string,
    onClick?: () => void
}

const Image: FC<IImage> = ({ src, alt, height = '100%', width = '100%', className, onClick, placeholder }) => {
    return (
        <img
            src={src ? src : placeholder}
            alt={alt}
            height={height}
            width={width}
            className={className}
            onClick={onClick}
            decoding="async"
            loading="lazy"
        />
    )
}


export default React.memo(Image)
